module.exports = __webpack_public_path__ + "img/sticker_23.d8e25a49.svg";